<template>
  <div class="changelog-container">
    <div v-if="minimized" class="minimized ms-3 me-3">
      <div class="row mb-3" v-for="item in systemVersions">
        <div class="col-8 text-start">
          <router-link to="/changelog/index"
            ><small>{{ item.build.name }}</small></router-link
          >
        </div>
        <div class="col-4 text-end">
          <router-link to="/changelog/index">
            <el-tag size="mini"
              ><small>{{ $i18n.t('version') }}</small>
              {{ item.build.version }}
            </el-tag>
          </router-link>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-for="system in systemVersions" class="mb-5">
        <el-descriptions :title="system.build.name" :column="2" border>
          <el-descriptions-item>
            <template slot="label">
              {{ $i18n.t('Version number') }}
            </template>
            {{ system.build.version }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              {{ $i18n.t('Version date') }}
            </template>
            {{ system.build.date }}
          </el-descriptions-item>
        </el-descriptions>

        <el-table :data="getChanges(system.changelog.changes[0].updates)" stripe class="w-100">
          <el-table-column prop="category" :label="$i18n.t('Category')" width="180"></el-table-column>
          <el-table-column prop="message" :label="$i18n.t('Description')"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from '@/components/modal/Modal'
import ModalOpener from '@/components/modal/Opener'

/**
 * @class Changelog
 *
 * @description this component fetches the Changelog_readChangelog api endpoint
 * and displays on itself
 */
export default {
  name: 'changelog',
  components: {
    Modal,
    ModalOpener,
  },
  props: {
    minimized: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      systemVersions: {},
    }
  },
  methods: {
    load() {
      this.$client
        .execute({
          operationId: 'Changelog_readChangelog',
          method: 'get',
        })
        .then(async (response) => {
          this.systemVersions = JSON.parse(response.data)
        })
        .catch((e) => console.error(e.message))
    },
    getChanges(changes) {
      const output = []
      for (const category in changes) {
        changes[category].forEach((item) => {
          output.push({
            category: category,
            hash: item.hash,
            message: item.message,
          })
        })
      }
      return output
    },
  },
  created() {
    this.load()
  },
}
</script>

<style lang="scss" scoped>
@import 'src/assets/sass/variables';
.changelog-container,
.changelog-container a {
  color: $color-text-primary;
}
.minimized {
  color: $color-text-light;
  a {
    color: $color-text-light;
    text-decoration: none;
    cursor: pointer;
  }
}
</style>
